import './styles.scss';
import React from 'react';

import {
  GlobalNavigation,
  Button,
  Row,
  Col,
  Card,
  Spacer,
  getGlobalParam
} from '@agilemd/web-components';

import Browser from './Browser/index.js';

const SUGGESTED_BROWSERS = [
  {
    name: 'Chrome',
    url: 'https://www.google.com/chrome',
    art: 'https://d2p53dh3qxfm0x.cloudfront.net/assets/logo/chrome-keejzcwy.png'
  },
  {
    name: 'Firefox',
    url: 'https://www.mozilla.org/en-US/firefox/new/',
    art: 'https://d2p53dh3qxfm0x.cloudfront.net/assets/logo/firefox-keejzcwy.png'
  },
  {
    name: 'Microsoft Edge',
    url: ' https://www.microsoft.com/en-us/edge',
    art: 'https://d2p53dh3qxfm0x.cloudfront.net/assets/logo/edge-keejzcwy.png'
  }
];

const {
  // @ts-ignore
  name: userName,
  // @ts-ignore
  emails: [{ address: userEmail, emailHash } = { address: '', emailHash: '' }]
} = getGlobalParam('account', { name: '', emails: [{}] });
const BROWSER = getGlobalParam('browser', 'unknown browser');
const OS = getGlobalParam('os', 'unknown OS');
const REDIRECT_TO = getGlobalParam('redirectTo', '/');

function ErrorPage() {
  return (
    <GlobalNavigation userName={userName} userEmail={userEmail} userEmailHash={emailHash}>
      <Row justify="center" align="center">
        <Col width={6} spacing={{ y: 10 }}>
          <Card variant="white" border="none" className="unsupported-browser__card">
            <h1 className="unsupported-browser__title">Browser not supported</h1>
            <p className="unsupported-browser__description">
              You are using an unsupported browser:
            </p>
            <Card width="auto" variant="half-padding" className="unsupported-browser__browser">
              {String(BROWSER)} on {String(OS)}
            </Card>
            <p className="unsupported-browser__description">
              Please use Chrome, Firefox or Microsoft Edge to access AgileMD&apos;s web
              applications.
            </p>
            <Spacer top={2} bottom={4}>
              {SUGGESTED_BROWSERS.map(browser => (
                <Browser
                  key={browser.name}
                  art={browser.art}
                  name={browser.name}
                  url={browser.url}
                />
              ))}
            </Spacer>
          </Card>
          <Spacer top={5}>
            <Button
              variant="transparent"
              className="unsupported-browser__continue"
              // @ts-ignore
              href={REDIRECT_TO}
            >
              Proceed anyway →
            </Button>
          </Spacer>
        </Col>
      </Row>
    </GlobalNavigation>
  );
}

export default ErrorPage;
